import React from 'react';
import { Redirect, Switch, Route, useRouteMatch } from 'react-router-dom';
import { Pages } from "components/pages";
import { useCanManageUserGroups } from "components/usergroup/hooks";


export default function UserGroupsRoute() {

    const { path } = useRouteMatch();
    const canManage = useCanManageUserGroups();

    return (
        <Switch>
            <Route path={ `${ path }` } exact>
                <Pages.UserGroup.Archive canManageUserGroups={ canManage } />
            </Route>
            <Route path={ `${ path }/page/:pageNum` } exact>
                <Pages.UserGroup.Archive canManageUserGroups={ canManage } />
            </Route>
            <Route path={ `${ path }/page` } exact>
                <Pages.UserGroup.Archive canManageUserGroups={ canManage } />
            </Route>
            <Route path={ `${ path }/create` } exact>
                { canManage ?
                    <Pages.UserGroup.Create canManageUserGroups={ canManage } /> :
                    <Redirect to={ path } /> }
            </Route>
            <Route path={ `${ path }/:id` } >
                { ({ match }) => <Pages.UserGroup.Single match={ match } canManageUserGroups={ canManage } exact /> }
            </Route>
        </Switch>
    );
}
